<template>
    <div class="main" />
</template>

<script>
export default {

    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {}

}

</script>

<style lang="scss" scoped>
h1 {
    height: 100px;
}

</style>
